export enum MultipartDocumentStatus {
  UPLOADED = 'uploaded',
  PROCESSING = 'processing',
  PENDING_REVIEW = 'pending_review',
  APPROVED = 'approved',
  SEPARATION_PROCESSING = 'separation_processing',
  SEPARATION_REVIEW = 'separation_review',
  SEPARATION_APPROVED = 'separation_approved',
  SEPARATION_COMPLETED = 'separation_completed',
}